export type IanaCanonTimezones = {
	[ key: string ]: {
		posix: string;
		description: string;
	};
};

export const IANA_CANON_TIMEZONES = <const>{
	"Africa/Abidjan": {
		posix: "GMT0",
		description: "Abidjan, Côte d’Ivoire (GMT+0:00)"
	},
	"Africa/Algiers": {
		posix: "CET-1",
		description: "Algiers, Algeria (GMT+1:00)"
	},
	"Africa/Bissau": {
		posix: "GMT0",
		description: "Bissau, Guinea-Bissau (GMT+0:00)"
	},
	"Africa/Cairo": {
		posix: "EET-2EEST,M4.5.5/0,M10.5.4/24",
		description: "Cairo, Egypt (GMT+2:00)"
	},
	"Africa/Casablanca": {
		posix: "<+01>-1",
		description: "Casablanca, Morocco (GMT+1:00)"
	},
	"Africa/Ceuta": {
		posix: "CET-1CEST,M3.5.0,M10.5.0/3",
		description: "Ceuta, Spain (GMT+1:00)"
	},
	"Africa/El_Aaiun": {
		posix: "<+01>-1",
		description: "El Aaiún, Western Sahara (GMT+1:00)"
	},
	"Africa/Johannesburg": {
		posix: "SAST-2",
		description: "Johannesburg, South Africa (GMT+2:00)"
	},
	"Africa/Juba": {
		posix: "CAT-2",
		description: "Juba, South Sudan (GMT+2:00)"
	},
	"Africa/Khartoum": {
		posix: "CAT-2",
		description: "Khartoum, Sudan (GMT+2:00)"
	},
	"Africa/Lagos": {
		posix: "WAT-1",
		description: "Lagos, Nigeria (GMT+1:00)"
	},
	"Africa/Maputo": {
		posix: "CAT-2",
		description: "Maputo, Mozambique (GMT+2:00)"
	},
	"Africa/Monrovia": {
		posix: "GMT0",
		description: "Monrovia, Liberia (GMT+0:00)"
	},
	"Africa/Nairobi": {
		posix: "EAT-3",
		description: "Nairobi, Kenya (GMT+3:00)"
	},
	"Africa/Ndjamena": {
		posix: "WAT-1",
		description: "Ndjamena, Chad (GMT+1:00)"
	},
	"Africa/Sao_Tome": {
		posix: "GMT0",
		description: "Sao Tome, São Tomé and Príncipe (GMT+0:00)"
	},
	"Africa/Tripoli": {
		posix: "EET-2",
		description: "Tripoli, Libya (GMT+2:00)"
	},
	"Africa/Tunis": {
		posix: "CET-1",
		description: "Tunis, Tunisia (GMT+1:00)"
	},
	"Africa/Windhoek": {
		posix: "CAT-2",
		description: "Windhoek, Namibia (GMT+2:00)"
	},
	"America/Adak": {
		posix: "HST10HDT,M3.2.0,M11.1.0",
		description: "Adak, Alaska, United States (GMT-10:00)"
	},
	"America/Anchorage": {
		posix: "AKST9AKDT,M3.2.0,M11.1.0",
		description: "Anchorage, Alaska, United States (GMT-9:00)"
	},
	"America/Araguaina": {
		posix: "<-03>3",
		description: "Araguaina, Brazil (GMT-3:00)"
	},
	"America/Argentina/Buenos_Aires": {
		posix: "<-03>3",
		description: "Buenos Aires, Argentina (GMT-3:00)"
	},
	"America/Argentina/Catamarca": {
		posix: "<-03>3",
		description: "Catamarca, Argentina (GMT-3:00)"
	},
	"America/Argentina/Cordoba": {
		posix: "<-03>3",
		description: "Cordoba, Argentina (GMT-3:00)"
	},
	"America/Argentina/Jujuy": {
		posix: "<-03>3",
		description: "Jujuy, Argentina (GMT-3:00)"
	},
	"America/Argentina/La_Rioja": {
		posix: "<-03>3",
		description: "La Rioja, Argentina (GMT-3:00)"
	},
	"America/Argentina/Mendoza": {
		posix: "<-03>3",
		description: "Mendoza, Argentina (GMT-3:00)"
	},
	"America/Argentina/Rio_Gallegos": {
		posix: "<-03>3",
		description: "Rio Gallegos, Argentina (GMT-3:00)"
	},
	"America/Argentina/Salta": {
		posix: "<-03>3",
		description: "Salta, Argentina (GMT-3:00)"
	},
	"America/Argentina/San_Juan": {
		posix: "<-03>3",
		description: "San Juan, Argentina (GMT-3:00)"
	},
	"America/Argentina/San_Luis": {
		posix: "<-03>3",
		description: "San Luis, Argentina (GMT-3:00)"
	},
	"America/Argentina/Tucuman": {
		posix: "<-03>3",
		description: "Tucuman, Argentina (GMT-3:00)"
	},
	"America/Argentina/Ushuaia": {
		posix: "<-03>3",
		description: "Ushuaia, Argentina (GMT-3:00)"
	},
	"America/Asuncion": {
		posix: "<-03>3",
		description: "Asuncion, Paraguay (GMT-3:00)"
	},
	"America/Bahia": {
		posix: "<-03>3",
		description: "Bahia, Brazil (GMT-3:00)"
	},
	"America/Bahia_Banderas": {
		posix: "CST6",
		description: "Bahia Banderas, Nayarit, Mexico (GMT-6:00)"
	},
	"America/Barbados": {
		posix: "AST4",
		description: "Bridgetown, Barbados (GMT-4:00)"
	},
	"America/Belem": {
		posix: "<-03>3",
		description: "Belem, Brazil (GMT-3:00)"
	},
	"America/Belize": {
		posix: "CST6",
		description: "Belize City, Belize (GMT-6:00)"
	},
	"America/Boa_Vista": {
		posix: "<-04>4",
		description: "Boa Vista, Brazil (GMT-4:00)"
	},
	"America/Bogota": {
		posix: "<-05>5",
		description: "Bogota, Colombia (GMT-5:00)"
	},
	"America/Boise": {
		posix: "MST7MDT,M3.2.0,M11.1.0",
		description: "Boise, Idaho, United States (GMT-7:00)"
	},
	"America/Cambridge_Bay": {
		posix: "MST7MDT,M3.2.0,M11.1.0",
		description: "Cambridge Bay, Canada (GMT-7:00)"
	},
	"America/Campo_Grande": {
		posix: "<-04>4",
		description: "Campo Grande, Brazil (GMT-4:00)"
	},
	"America/Cancun": {
		posix: "EST5",
		description: "Cancun, Quintana Roo, Mexico (GMT-5:00)"
	},
	"America/Caracas": {
		posix: "<-04>4",
		description: "Caracas, Venezuela (GMT-4:00)"
	},
	"America/Cayenne": {
		posix: "<-03>3",
		description: "Cayenne, French Guiana (GMT-3:00)"
	},
	"America/Chicago": {
		posix: "CST6CDT,M3.2.0,M11.1.0",
		description: "Chicago, Illinois, United States (GMT-6:00)"
	},
	"America/Chihuahua": {
		posix: "CST6",
		description: "Chihuahua City, Chihuahua, Mexico (GMT-7:00)"
	},
	"America/Ciudad_Juarez": {
		posix: "MST7MDT,M3.2.0,M11.1.0",
		description: "Ciudad Juarez, Chihuahua, Mexico (GMT-7:00)"
	},
	"America/Costa_Rica": {
		posix: "CST6",
		description: "Costa Rica, Costa Rica (GMT-6:00)"
	},
	"America/Coyhaique": {
		posix: "<-03>3",
		description: "Coyhaique, Chile (GMT-3:00)"
	},
	"America/Cuiaba": {
		posix: "<-04>4",
		description: "Cuiaba, Brazil (GMT-4:00)"
	},
	"America/Danmarkshavn": {
		posix: "GMT0",
		description: "Danmarkshavn, Greenland (GMT-0:00)"
	},
	"America/Dawson": {
		posix: "MST7",
		description: "Dawson, Canada (GMT-7:00)"
	},
	"America/Dawson_Creek": {
		posix: "MST7",
		description: "Dawson Creek, Canada (GMT-7:00)"
	},
	"America/Denver": {
		posix: "MST7MDT,M3.2.0,M11.1.0",
		description: "Denver, Colorado, United States (GMT-7:00)"
	},
	"America/Detroit": {
		posix: "EST5EDT,M3.2.0,M11.1.0",
		description: "Detroit, Michigan, United States (GMT-5:00)"
	},
	"America/Edmonton": {
		posix: "MST7MDT,M3.2.0,M11.1.0",
		description: "Edmonton, Alberta, Canada (GMT-7:00)"
	},
	"America/Eirunepe": {
		posix: "<-05>5",
		description: "Eirunepe, Brazil (GMT-5:00)"
	},
	"America/El_Salvador": {
		posix: "CST6",
		description: "El Salvador, El Salvador (GMT-6:00)"
	},
	"America/Fort_Nelson": {
		posix: "MST7",
		description: "Fort Nelson, British Columbia, Canada (GMT-7:00)"
	},
	"America/Fortaleza": {
		posix: "<-03>3",
		description: "Fortaleza, Brazil (GMT-3:00)"
	},
	"America/Glace_Bay": {
		posix: "AST4ADT,M3.2.0,M11.1.0",
		description: "Glace Bay, Nova Scotia, Canada (GMT-4:00)"
	},
	"America/Goose_Bay": {
		posix: "AST4ADT,M3.2.0,M11.1.0",
		description: "Goose Bay, Newfoundland and Labrador, Canada (GMT-4:00)"
	},
	"America/Grand_Turk": {
		posix: "EST5EDT,M3.2.0,M11.1.0",
		description: "Grand Turk, Turks and Caicos Islands (GMT-5:00)"
	},
	"America/Guatemala": {
		posix: "CST6",
		description: "Guatemala City, Guatemala (GMT-6:00)"
	},
	"America/Guayaquil": {
		posix: "<-05>5",
		description: "Guayaquil, Ecuador (GMT-5:00)"
	},
	"America/Guyana": {
		posix: "<-04>4",
		description: "Georgetown, Guyana (GMT-4:00)"
	},
	"America/Halifax": {
		posix: "AST4ADT,M3.2.0,M11.1.0",
		description: "Halifax, Nova Scotia, Canada (GMT-4:00)"
	},
	"America/Havana": {
		posix: "CST5CDT,M3.2.0/0,M11.1.0/1",
		description: "Havana, Cuba (GMT-5:00)"
	},
	"America/Hermosillo": {
		posix: "MST7",
		description: "Hermosillo, Sonora, Mexico (GMT-7:00)"
	},
	"America/Indiana/Indianapolis": {
		posix: "EST5EDT,M3.2.0,M11.1.0",
		description: "Indianapolis, Indiana, United States (GMT-5:00)"
	},
	"America/Indiana/Knox": {
		posix: "CST6CDT,M3.2.0,M11.1.0",
		description: "Knox, Indiana, United States (GMT-6:00)"
	},
	"America/Indiana/Marengo": {
		posix: "EST5EDT,M3.2.0,M11.1.0",
		description: "Marengo, Indiana, United States (GMT-5:00)"
	},
	"America/Indiana/Petersburg": {
		posix: "EST5EDT,M3.2.0,M11.1.0",
		description: "Petersburg, Indiana, United States (GMT-5:00)"
	},
	"America/Indiana/Tell_City": {
		posix: "CST6CDT,M3.2.0,M11.1.0",
		description: "Tell City, Indiana, United States (GMT-6:00)"
	},
	"America/Indiana/Vevay": {
		posix: "EST5EDT,M3.2.0,M11.1.0",
		description: "Vevay, Indiana, United States (GMT-5:00)"
	},
	"America/Indiana/Vincennes": {
		posix: "EST5EDT,M3.2.0,M11.1.0",
		description: "Vincennes, Indiana, United States (GMT-5:00)"
	},
	"America/Indiana/Winamac": {
		posix: "EST5EDT,M3.2.0,M11.1.0",
		description: "Winamac, Indiana, United States (GMT-5:00)"
	},
	"America/Inuvik": {
		posix: "MST7MDT,M3.2.0,M11.1.0",
		description: "Inuvik, Northwest Territories, Canada (GMT-7:00)"
	},
	"America/Iqaluit": {
		posix: "EST5EDT,M3.2.0,M11.1.0",
		description: "Iqaluit, Nunavut, Canada (GMT-5:00)"
	},
	"America/Jamaica": {
		posix: "EST5",
		description: "Kingston, Jamaica (GMT-5:00)"
	},
	"America/Juneau": {
		posix: "AKST9AKDT,M3.2.0,M11.1.0",
		description: "Juneau, Alaska, United States (GMT-9:00)"
	},
	"America/Kentucky/Louisville": {
		posix: "EST5EDT,M3.2.0,M11.1.0",
		description: "Louisville, Kentucky, United States (GMT-5:00)"
	},
	"America/Kentucky/Monticello": {
		posix: "EST5EDT,M3.2.0,M11.1.0",
		description: "Monticello, Kentucky, United States (GMT-5:00)"
	},
	"America/La_Paz": {
		posix: "<-04>4",
		description: "La Paz, Bolivia (GMT-4:00)"
	},
	"America/Lima": {
		posix: "<-05>5",
		description: "Lima, Peru (GMT-5:00)"
	},
	"America/Los_Angeles": {
		posix: "PST8PDT,M3.2.0,M11.1.0",
		description: "Los Angeles, California, United States (GMT-8:00)"
	},
	"America/Maceio": {
		posix: "<-03>3",
		description: "Maceio, Brazil (GMT-3:00)"
	},
	"America/Managua": {
		posix: "CST6",
		description: "Managua, Nicaragua (GMT-6:00)"
	},
	"America/Manaus": {
		posix: "<-04>4",
		description: "Manaus, Brazil (GMT-4:00)"
	},
	"America/Martinique": {
		posix: "AST4",
		description: "Martinique, Martinique (GMT-4:00)"
	},
	"America/Matamoros": {
		posix: "CST6CDT,M3.2.0,M11.1.0",
		description: "Matamoros, Tamaulipas, Mexico (GMT-6:00)"
	},
	"America/Mazatlan": {
		posix: "MST7",
		description: "Mazatlan, Sinaloa, Mexico (GMT-7:00)"
	},
	"America/Menominee": {
		posix: "CST6CDT,M3.2.0,M11.1.0",
		description: "Menominee, Michigan, United States (GMT-6:00)"
	},
	"America/Merida": {
		posix: "CST6",
		description: "Merida, Yucatán, Mexico (GMT-6:00)"
	},
	"America/Metlakatla": {
		posix: "AKST9AKDT,M3.2.0,M11.1.0",
		description: "Metlakatla, Alaska, United States (GMT-9:00)"
	},
	"America/Mexico_City": {
		posix: "CST6",
		description: "Mexico City, Mexico (GMT-6:00)"
	},
	"America/Miquelon": {
		posix: "<-03>3<-02>,M3.2.0,M11.1.0",
		description: "Miquelon, Saint Pierre and Miquelon (GMT-3:00)"
	},
	"America/Moncton": {
		posix: "AST4ADT,M3.2.0,M11.1.0",
		description: "Moncton, New Brunswick, Canada (GMT-4:00)"
	},
	"America/Monterrey": {
		posix: "CST6",
		description: "Monterrey, Nuevo León, Mexico (GMT-6:00)"
	},
	"America/Montevideo": {
		posix: "<-03>3",
		description: "Montevideo, Uruguay (GMT-3:00)"
	},
	"America/New_York": {
		posix: "EST5EDT,M3.2.0,M11.1.0",
		description: "New York, New York, United States (GMT-5:00)"
	},
	"America/Nome": {
		posix: "AKST9AKDT,M3.2.0,M11.1.0",
		description: "Nome, Alaska, United States (GMT-9:00)"
	},
	"America/Noronha": {
		posix: "<-02>2",
		description: "Noronha, Brazil (GMT-2:00)"
	},
	"America/North_Dakota/Beulah": {
		posix: "CST6CDT,M3.2.0,M11.1.0",
		description: "Beulah, North Dakota, United States (GMT-6:00)"
	},
	"America/North_Dakota/Center": {
		posix: "CST6CDT,M3.2.0,M11.1.0",
		description: "Center, North Dakota, United States (GMT-6:00)"
	},
	"America/North_Dakota/New_Salem": {
		posix: "CST6CDT,M3.2.0,M11.1.0",
		description: "New Salem, North Dakota, United States (GMT-6:00)"
	},
	"America/Nuuk": {
		posix: "<-02>2<-01>,M3.5.0/-1,M10.5.0/0",
		description: "Nuuk, Greenland (GMT-2:00)"
	},
	"America/Ojinaga": {
		posix: "CST6CDT,M3.2.0,M11.1.0",
		description: "Ojinaga, Chihuahua, Mexico (GMT-6:00)"
	},
	"America/Panama": {
		posix: "EST5",
		description: "Panama City, Panama (GMT-5:00)"
	},
	"America/Paramaribo": {
		posix: "<-03>3",
		description: "Paramaribo, Suriname (GMT-3:00)"
	},
	"America/Phoenix": {
		posix: "MST7",
		description: "Phoenix, Arizona, United States (GMT-7:00)"
	},
	"America/Port-au-Prince": {
		posix: "EST5EDT,M3.2.0,M11.1.0",
		description: "Port-au-Prince, Haiti (GMT-5:00)"
	},
	"America/Porto_Velho": {
		posix: "<-04>4",
		description: "Porto Velho, Brazil (GMT-4:00)"
	},
	"America/Puerto_Rico": {
		posix: "AST4",
		description: "San Juan, Puerto Rico (GMT-4:00)"
	},
	"America/Punta_Arenas": {
		posix: "<-03>3",
		description: "Punta_Arenas, Chile (GMT-3:00)"
	},
	"America/Rankin_Inlet": {
		posix: "CST6CDT,M3.2.0,M11.1.0",
		description: "Rankin Inlet, Nunavut, Canada (GMT-6:00)"
	},
	"America/Recife": {
		posix: "<-03>3",
		description: "Recife, Brazil (GMT-3:00)"
	},
	"America/Regina": {
		posix: "CST6",
		description: "Regina, Saskatchewan, Canada (GMT-6:00)"
	},
	"America/Resolute": {
		posix: "CST6CDT,M3.2.0,M11.1.0",
		description: "Resolute, Nunavut, Canada (GMT-6:00)"
	},
	"America/Rio_Branco": {
		posix: "<-05>5",
		description: "Rio Branco, Brazil (GMT-5:00)"
	},
	"America/Santarem": {
		posix: "<-03>3",
		description: "Santarem, Brazil (GMT-3:00)"
	},
	"America/Santiago": {
		posix: "<-04>4<-03>,M9.1.6/24,M4.1.6/24",
		description: "Santiago, Chile (GMT-4:00)"
	},
	"America/Santo_Domingo": {
		posix: "AST4",
		description: "Santo Domingo, Dominican Republic (GMT-4:00)"
	},
	"America/Sao_Paulo": {
		posix: "<-03>3",
		description: "Sao Paulo, Brazil (GMT-3:00)"
	},
	"America/Scoresbysund": {
		posix: "<-02>2<-01>,M3.5.0/-1,M10.5.0/0",
		description: "Scoresbysund, Greenland (GMT-2:00)"
	},
	"America/Sitka": {
		posix: "AKST9AKDT,M3.2.0,M11.1.0",
		description: "Sitka, Alaska, United States (GMT-9:00)"
	},
	"America/St_Johns": {
		posix: "NST3:30NDT,M3.2.0,M11.1.0",
		description: "St Johns, Newfoundland and Labrador, Canada (GMT-3:30)"
	},
	"America/Swift_Current": {
		posix: "CST6",
		description: "Swift Current, Saskatchewan, Canada (GMT-6:00)"
	},
	"America/Tegucigalpa": {
		posix: "CST6",
		description: "Tegucigalpa, Honduras (GMT-6:00)"
	},
	"America/Thule": {
		posix: "AST4ADT,M3.2.0,M11.1.0",
		description: "Thule, Greenland (GMT-4:00)"
	},
	"America/Tijuana": {
		posix: "PST8PDT,M3.2.0,M11.1.0",
		description: "Tijuana, Baja California, Mexico (GMT-8:00)"
	},
	"America/Toronto": {
		posix: "EST5EDT,M3.2.0,M11.1.0",
		description: "Toronto, Ontario, Canada (GMT-5:00)"
	},
	"America/Vancouver": {
		posix: "PST8PDT,M3.2.0,M11.1.0",
		description: "Vancouver, British Columbia, Canada (GMT-8:00)"
	},
	"America/Whitehorse": {
		posix: "MST7",
		description: "Whitehorse, Yukon, Canada (GMT-7:00)"
	},
	"America/Winnipeg": {
		posix: "CST6CDT,M3.2.0,M11.1.0",
		description: "Winnipeg, Manitoba, Canada (GMT-6:00)"
	},
	"America/Yakutat": {
		posix: "AKST9AKDT,M3.2.0,M11.1.0",
		description: "Yakutat, Alaska, United States (GMT-9:00)"
	},
	"Antarctica/Casey": {
		posix: "<+08>-8",
		description: "Casey, Antarctica (GMT+8:00)"
	},
	"Antarctica/Davis": {
		posix: "<+07>-7",
		description: "Davis, Antarctica (GMT+7:00)"
	},
	"Antarctica/Macquarie": {
		posix: "AEST-10AEDT,M10.1.0,M4.1.0/3",
		description: "Macquarie Island, Australia (GMT+10:00)"
	},
	"Antarctica/Mawson": {
		posix: "<+05>-5",
		description: "Mawson, Antarctica (GMT+5:00)"
	},
	"Antarctica/Palmer": {
		posix: "<-03>3",
		description: "Palmer, Antarctica (GMT-3:00)"
	},
	"Antarctica/Rothera": {
		posix: "<-03>3",
		description: "Rothera, Antarctica (GMT-3:00)"
	},
	"Antarctica/Troll": {
		posix: "<+00>0<+02>-2,M3.5.0/1,M10.5.0/3",
		description: "Troll, Antarctica (GMT+0:00)"
	},
	"Antarctica/Vostok": {
		posix: "<+05>-5",
		description: "Vostok, Antarctica (GMT+5:00)"
	},
	"Asia/Almaty": {
		posix: "<+05>-5",
		description: "Almaty, Kazakhstan (GMT+5:00)"
	},
	"Asia/Amman": {
		posix: "<+03>-3",
		description: "Amman, Jordan (GMT+3:00)"
	},
	"Asia/Anadyr": {
		posix: "<+12>-12",
		description: "Anadyr, Russia (GMT+12:00)"
	},
	"Asia/Aqtau": {
		posix: "<+05>-5",
		description: "Aqtau, Kazakhstan (GMT+5:00)"
	},
	"Asia/Aqtobe": {
		posix: "<+05>-5",
		description: "Aqtobe, Kazakhstan (GMT+5:00)"
	},
	"Asia/Ashgabat": {
		posix: "<+05>-5",
		description: "Ashgabat, Turkmenistan (GMT+5:00)"
	},
	"Asia/Atyrau": {
		posix: "<+05>-5",
		description: "Atyrau, Kazakhstan (GMT+5:00)"
	},
	"Asia/Baghdad": {
		posix: "<+03>-3",
		description: "Baghdad, Iraq (GMT+3:00)"
	},
	"Asia/Baku": {
		posix: "<+04>-4",
		description: "Baku, Azerbaijan (GMT+4:00)"
	},
	"Asia/Bangkok": {
		posix: "<+07>-7",
		description: "Bangkok, Thailand (GMT+7:00)"
	},
	"Asia/Barnaul": {
		posix: "<+07>-7",
		description: "Barnaul, Russia (GMT+7:00)"
	},
	"Asia/Beirut": {
		posix: "EET-2EEST,M3.5.0/0,M10.5.0/0",
		description: "Beirut, Lebanon (GMT+2:00)"
	},
	"Asia/Bishkek": {
		posix: "<+06>-6",
		description: "Bishkek, Kyrgyzstan (GMT+6:00)"
	},
	"Asia/Chita": {
		posix: "<+09>-9",
		description: "Chita, Russia (GMT+9:00)"
	},
	"Asia/Colombo": {
		posix: "<+0530>-5:30",
		description: "Colombo, Sri Lanka (GMT+5:30)"
	},
	"Asia/Damascus": {
		posix: "<+03>-3",
		description: "Damascus, Syria (GMT+3:00)"
	},
	"Asia/Dhaka": {
		posix: "<+06>-6",
		description: "Dhaka, Bangladesh (GMT+6:00)"
	},
	"Asia/Dili": {
		posix: "<+09>-9",
		description: "Dili, East Timor (GMT+9:00)"
	},
	"Asia/Dubai": {
		posix: "<+04>-4",
		description: "Dubai, United Arab Emirates (GMT+4:00)"
	},
	"Asia/Dushanbe": {
		posix: "<+05>-5",
		description: "Dushanbe, Tajikistan (GMT+5:00)"
	},
	"Asia/Famagusta": {
		posix: "EET-2EEST,M3.5.0/3,M10.5.0/4",
		description: "Famagusta, Cyprus (GMT+2:00)"
	},
	"Asia/Gaza": {
		posix: "EET-2EEST,M3.4.4/50,M10.4.4/50",
		description: "Gaza, Palestine (GMT+2:00)"
	},
	"Asia/Hebron": {
		posix: "EET-2EEST,M3.4.4/50,M10.4.4/50",
		description: "Hebron, Palestine (GMT+2:00)"
	},
	"Asia/Ho_Chi_Minh": {
		posix: "<+07>-7",
		description: "Ho Chi Minh City, Vietnam (GMT+7:00)"
	},
	"Asia/Hong_Kong": {
		posix: "HKT-8",
		description: "Hong Kong, Hong Kong (GMT+8:00)"
	},
	"Asia/Hovd": {
		posix: "<+07>-7",
		description: "Hovd, Mongolia (GMT+7:00)"
	},
	"Asia/Irkutsk": {
		posix: "<+08>-8",
		description: "Irkutsk, Russia (GMT+8:00)"
	},
	"Asia/Jakarta": {
		posix: "WIB-7",
		description: "Jakarta, Indonesia (GMT+7:00)"
	},
	"Asia/Jayapura": {
		posix: "WIT-9",
		description: "Jayapura, Indonesia (GMT+9:00)"
	},
	"Asia/Jerusalem": {
		posix: "IST-2IDT,M3.4.4/26,M10.5.0",
		description: "Jerusalem, Israel (GMT+2:00)"
	},
	"Asia/Kabul": {
		posix: "<+0430>-4:30",
		description: "Kabul, Afghanistan (GMT+4:30)"
	},
	"Asia/Kamchatka": {
		posix: "<+12>-12",
		description: "Kamchatka, Russia (GMT+12:00)"
	},
	"Asia/Karachi": {
		posix: "PKT-5",
		description: "Karachi, Pakistan (GMT+5:00)"
	},
	"Asia/Kathmandu": {
		posix: "<+0545>-5:45",
		description: "Kathmandu, Nepal (GMT+5:45)"
	},
	"Asia/Khandyga": {
		posix: "<+09>-9",
		description: "Khandyga, Russia (GMT+9:00)"
	},
	"Asia/Kolkata": {
		posix: "IST-5:30",
		description: "Kolkata, India (GMT+5:30)"
	},
	"Asia/Krasnoyarsk": {
		posix: "<+07>-7",
		description: "Krasnoyarsk, Russia (GMT+7:00)"
	},
	"Asia/Kuching": {
		posix: "<+08>-8",
		description: "Kuching, Malaysia (GMT+8:00)"
	},
	"Asia/Macau": {
		posix: "CST-8",
		description: "Macau, China (GMT+8:00)"
	},
	"Asia/Magadan": {
		posix: "<+11>-11",
		description: "Magadan, Russia (GMT+11:00)"
	},
	"Asia/Makassar": {
		posix: "WITA-8",
		description: "Makassar, Indonesia (GMT+8:00)"
	},
	"Asia/Manila": {
		posix: "PST-8",
		description: "Manila, Philippines (GMT+8:00)"
	},
	"Asia/Nicosia": {
		posix: "EET-2EEST,M3.5.0/3,M10.5.0/4",
		description: "Nicosia, Cyprus (GMT+2:00)"
	},
	"Asia/Novokuznetsk": {
		posix:"<+07>-7",
		description: "Novokuznetsk, Russia (GMT+7:00)"
	},
	"Asia/Novosibirsk": {
		posix: "<+07>-7",
		description: "Novosibirsk, Russia (GMT+7:00)"
	},
	"Asia/Omsk": {
		posix: "<+06>-6",
		description: "Omsk, Russia (GMT+6:00)"
	},
	"Asia/Oral": {
		posix: "<+05>-5",
		description: "Oral, Kazakhstan (GMT+5:00)"
	},
	"Asia/Pontianak": {
		posix: "WIB-7",
		description: "Pontianak, Indonesia (GMT+7:00)"
	},
	"Asia/Pyongyang": {
		posix: "KST-9",
		description: "Pyongyang, North Korea (GMT+9:00)"
	},
	"Asia/Qatar": {
		posix: "<+03>-3",
		description: "Doha, Qatar (GMT+3:00)"
	},
	"Asia/Qyzylorda": {
		posix: "<+05>-5",
		description: "Qyzylorda, Kazakhstan (GMT+5:00)"
	},
	"Asia/Riyadh": {
		posix: "<+03>-3",
		description: "Riyadh, Saudi Arabia (GMT+3:00)"
	},
	"Asia/Sakhalin": {
		posix: "<+11>-11",
		description: "Sakhalin, Russia (GMT+11:00)"
	},
	"Asia/Samarkand": {
		posix: "<+05>-5",
		description: "Samarkand, Uzbekistan (GMT+5:00)"
	},
	"Asia/Seoul": {
		posix: "KST-9",
		description: "Seoul, South Korea (GMT+9:00)"
	},
	"Asia/Shanghai": {
		posix: "CST-8",
		description: "Shanghai, China (GMT+8:00)"
	},
	"Asia/Singapore": {
		posix: "<+08>-8",
		description: "Singapore, Singapore (GMT+8:00)"
	},
	"Asia/Srednekolymsk": {
		posix: "<+11>-11",
		description: "Srednekolymsk, Russia (GMT+11:00)"
	},
	"Asia/Taipei": {
		posix: "CST-8",
		description: "Taipei, Taiwan (GMT+8:00)"
	},
	"Asia/Tashkent": {
		posix: "<+05>-5",
		description: "Tashkent, Uzbekistan (GMT+5:00)"
	},
	"Asia/Tbilisi": {
		posix: "<+04>-4",
		description: "Tbilisi, Georgia (GMT+4:00)"
	},
	"Asia/Tehran": {
		posix: "<+0330>-3:30",
		description: "Tehran, Iran (GMT+3:30)"
	},
	"Asia/Thimphu": {
		posix: "<+06>-6",
		description: "Thimphu, Bhutan (GMT+6:00)"
	},
	"Asia/Tokyo": {
		posix: "JST-9",
		description: "Tokyo, Japan (GMT+9:00)"
	},
	"Asia/Tomsk": {
		posix: "<+07>-7",
		description: "Tomsk, Russia (GMT+7:00)"
	},
	"Asia/Ulaanbaatar": {
		posix: "<+08>-8",
		description: "Ulaanbaatar, Mongolia (GMT+8:00)"
	},
	"Asia/Urumqi": {
		posix: "<+06>-6",
		description: "Urumqi, China (GMT+6:00)"
	},
	"Asia/Ust-Nera": {
		posix: "<+10>-10",
		description: "Ust-Nera, Russia (GMT+10:00)"
	},
	"Asia/Vladivostok": {
		posix: "<+10>-10",
		description: "Vladivostok, Russia (GMT+10:00)"
	},
	"Asia/Yakutsk": {
		posix: "<+09>-9",
		description: "Yakutsk, Russia (GMT+9:00)"
	},
	"Asia/Yangon": {
		posix: "<+0630>-6:30",
		description: "Yangon, Myanmar (GMT+6:30)"
	},
	"Asia/Yekaterinburg": {
		posix: "<+05>-5",
		description: "Yekaterinburg, Russia (GMT+5:00)"
	},
	"Asia/Yerevan": {
		posix: "<+04>-4",
		description: "Yerevan, Armenia (GMT+4:00)"
	},
	"Atlantic/Azores": {
		posix: "<-01>1<+00>,M3.5.0/0,M10.5.0/1",
		description: "Azores, Portugal (GMT-1:00)"
	},
	"Atlantic/Bermuda": {
		posix: "AST4ADT,M3.2.0,M11.1.0",
		description: "Hamilton, Bermuda (GMT-4:00)"
	},
	"Atlantic/Canary": {
		posix: "WET0WEST,M3.5.0/1,M10.5.0",
		description: "Canary Islands, Spain (GMT+0:00)"
	},
	"Atlantic/Cape_Verde": {
		posix: "<-01>1",
		description: "Praia, Cape Verde (GMT-1:00)"
	},
	"Atlantic/Faroe": {
		posix: "WET0WEST,M3.5.0/1,M10.5.0",
		description: "Tórshavn, Faroe Islands (GMT+0:00)"
	},
	"Atlantic/Madeira": {
		posix: "WET0WEST,M3.5.0/1,M10.5.0",
		description: "Madeira, Portugal (GMT+0:00)"
	},
	"Atlantic/South_Georgia": {
		posix: "<-02>2",
		description: "King Edward Point, South Georgia and the South Sandwich Islands (GMT-2:00)"
	},
	"Atlantic/Stanley": {
		posix: "<-03>3",
		description: "Stanley, Falkland Islands (GMT-3:00)"
	},
	"Australia/Adelaide": {
		posix: "ACST-9:30ACDT,M10.1.0,M4.1.0/3",
		description: "Adelaide, South Australia, Australia (GMT+9:30)"
	},
	"Australia/Brisbane": {
		posix: "AEST-10",
		description: "Brisbane, Queensland, Australia (GMT+10:00)"
	},
	"Australia/Broken_Hill": {
		posix: "ACST-9:30ACDT,M10.1.0,M4.1.0/3",
		description: "Broken Hill, New South Wales, Australia (GMT+9:30)"
	},
	"Australia/Darwin": {
		posix: "ACST-9:30",
		description: "Darwin, Northern Territory, Australia (GMT+9:30)"
	},
	"Australia/Eucla": {
		posix:"<+0845>-8:45",
		description: "Eucla, Western Australia, Australia (GMT+8:45)"
	},
	"Australia/Hobart": {
		posix: "AEST-10AEDT,M10.1.0,M4.1.0/3",
		description: "Hobart, Tasmania, Australia (GMT+10:00)"
	},
	"Australia/Lindeman": {
		posix: "AEST-10",
		description: "Lindeman, Queensland, Australia (GMT+10:00)"
	},
	"Australia/Lord_Howe": {
		posix: "<+1030>-10:30<+11>-11,M10.1.0,M4.1.0",
		description: "Lord Howe Island, New South Wales, Australia (GMT+10:30)"
	},
	"Australia/Melbourne": {
		posix: "AEST-10AEDT,M10.1.0,M4.1.0/3",
		description: "Melbourne, Victoria, Australia (GMT+10:00)"
	},
	"Australia/Perth": {
		posix: "AWST-8",
		description: "Perth, Western Australia, Australia (GMT+8:00)"
	},
	"Australia/Sydney": {
		posix: "AEST-10AEDT,M10.1.0,M4.1.0/3",
		description: "Sydney, New South Wales, Australia (GMT+10:00)"
	},
	"Etc/GMT": {
		posix: "GMT0",
		description: "UTC (GMT+0:00)"
	},
	"Europe/Andorra": {
		posix: "CET-1CEST,M3.5.0,M10.5.0/3",
		description: "Andorra la Vella, Andorra (GMT+1:00)"
	},
	"Europe/Astrakhan": {
		posix: "<+04>-4",
		description: "Astrakhan, Russia (GMT+4:00)"
	},
	"Europe/Athens": {
		posix: "EET-2EEST,M3.5.0/3,M10.5.0/4",
		description: "Athens, Greece (GMT+2:00)"
	},
	"Europe/Belgrade": {
		posix: "CET-1CEST,M3.5.0,M10.5.0/3",
		description: "Belgrade, Serbia (GMT+1:00)"
	},
	"Europe/Berlin": {
		posix: "CET-1CEST,M3.5.0,M10.5.0/3",
		description: "Berlin, Germany (GMT+1:00)"
	},
	"Europe/Brussels": {
		posix: "CET-1CEST,M3.5.0,M10.5.0/3",
		description: "Brussels, Belgium (GMT+1:00)"
	},
	"Europe/Bucharest": {
		posix: "EET-2EEST,M3.5.0/3,M10.5.0/4",
		description: "Bucharest, Romania (GMT+2:00)"
	},
	"Europe/Budapest": {
		posix: "CET-1CEST,M3.5.0,M10.5.0/3",
		description: "Budapest, Hungary (GMT+1:00)"
	},
	"Europe/Chisinau": {
		posix: "EET-2EEST,M3.5.0,M10.5.0/3",
		description: "Chisinau, Moldova (GMT+2:00)"
	},
	"Europe/Dublin": {
		posix: "IST-1GMT0,M10.5.0,M3.5.0/1",
		description: "Dublin, Ireland (GMT+0:00)"
	},
	"Europe/Gibraltar": {
		posix: "CET-1CEST,M3.5.0,M10.5.0/3",
		description: "Gibraltar, Gibraltar (GMT+1:00)"
	},
	"Europe/Helsinki": {
		posix: "EET-2EEST,M3.5.0/3,M10.5.0/4",
		description: "Helsinki, Finland (GMT+2:00)"
	},
	"Europe/Istanbul": {
		posix: "<+03>-3",
		description: "Istanbul, Turkey (GMT+3:00)"
	},
	"Europe/Kaliningrad": {
		posix: "EET-2",
		description: "Kaliningrad, Russia (GMT+2:00)"
	},
	"Europe/Kirov": {
		posix: "MSK-3",
		description: "Kirov, Russia (GMT+3:00)"
	},
	"Europe/Kyiv": {
		posix: "EET-2EEST,M3.5.0/3,M10.5.0/4",
		description: "Kyiv, Ukraine (GMT+2:00)"
	},
	"Europe/Lisbon": {
		posix: "WET0WEST,M3.5.0/1,M10.5.0",
		description: "Lisbon, Portugal (GMT+0:00)"
	},
	"Europe/London": {
		posix: "GMT0BST,M3.5.0/1,M10.5.0",
		description: "London, United Kingdom (GMT+0:00)"
	},
	"Europe/Madrid": {
		posix: "CET-1CEST,M3.5.0,M10.5.0/3",
		description: "Madrid, Spain (GMT+1:00)"
	},
	"Europe/Malta": {
		posix: "CET-1CEST,M3.5.0,M10.5.0/3",
		description: "Valleta, Malta (GMT+1:00)"
	},
	"Europe/Minsk": {
		posix: "<+03>-3",
		description: "Minsk, Belarus (GMT+3:00)"
	},
	"Europe/Moscow": {
		posix: "MSK-3",
		description: "Moscow, Russia (GMT+3:00)"
	},
	"Europe/Paris": {
		posix: "CET-1CEST,M3.5.0,M10.5.0/3",
		description: "Paris, France (GMT+1:00)"
	},
	"Europe/Prague": {
		posix: "CET-1CEST,M3.5.0,M10.5.0/3",
		description: "Prague, Czech Republic (GMT+1:00)"
	},
	"Europe/Riga": {
		posix: "EET-2EEST,M3.5.0/3,M10.5.0/4",
		description: "Riga, Latvia (GMT+2:00)"
	},
	"Europe/Rome": {
		posix: "CET-1CEST,M3.5.0,M10.5.0/3",
		description: "Rome, Italy (GMT+1:00)"
	},
	"Europe/Samara": {
		posix: "<+04>-4",
		description: "Samara, Russia (GMT+4:00)"
	},
	"Europe/Saratov": {
		posix: "<+04>-4",
		description: "Saratov, Russia (GMT+4:00)"
	},
	"Europe/Simferopol": {
		posix: "MSK-3",
		description: "Simferopol, Ukraine (GMT+3:00)"
	},
	"Europe/Sofia": {
		posix: "EET-2EEST,M3.5.0/3,M10.5.0/4",
		description: "Sofia, Bulgaria (GMT+2:00)"
	},
	"Europe/Tallinn": {
		posix: "EET-2EEST,M3.5.0/3,M10.5.0/4",
		description: "Tallinn, Estonia (GMT+2:00)"
	},
	"Europe/Tirane": {
		posix: "CET-1CEST,M3.5.0,M10.5.0/3",
		description: "Tirane, Albania (GMT+1:00)"
	},
	"Europe/Ulyanovsk": {
		posix: "<+04>-4",
		description: "Ulyanovsk, Russia (GMT+4:00)"
	},
	"Europe/Vienna": {
		posix: "CET-1CEST,M3.5.0,M10.5.0/3",
		description: "Vienna, Austria (GMT+1:00)"
	},
	"Europe/Vilnius": {
		posix: "EET-2EEST,M3.5.0/3,M10.5.0/4",
		description: "Vilnius, Lithuania (GMT+2:00)"
	},
	"Europe/Volgograd": {
		posix: "MSK-3",
		description: "Volgograd, Russia (GMT+3:00)"
	},
	"Europe/Warsaw": {
		posix: "CET-1CEST,M3.5.0,M10.5.0/3",
		description: "Warsaw, Poland (GMT+1:00)"
	},
	"Europe/Zurich": {
		posix: "CET-1CEST,M3.5.0,M10.5.0/3",
		description: "Zurich, Switzerland (GMT+1:00)"
	},
	"Indian/Chagos": {
		posix: "<+06>-6",
		description: "Chagos, British Indian Ocean Territory (GMT+6:00)"
	},
	"Indian/Maldives": {
		posix: "<+05>-5",
		description: "Malé, Maldives (GMT+5:00)"
	},
	"Indian/Mauritius": {
		posix: "<+04>-4",
		description: "Port Louis, Mauritius (GMT+4:00)"
	},
	"Pacific/Apia": {
		posix: "<+13>-13",
		description: "Apia, Samoa (GMT+13:00)"
	},
	"Pacific/Auckland": {
		posix: "NZST-12NZDT,M9.5.0,M4.1.0/3",
		description: "Auckland, New Zealand (GMT+12:00)"
	},
	"Pacific/Bougainville": {
		posix: "<+11>-11",
		description: "Bougainville, Papua New Guinea (GMT+11:00)"
	},
	"Pacific/Chatham": {
		posix: "<+1245>-12:45<+1345>,M9.5.0/2:45,M4.1.0/3:45",
		description: "Chatham, New Zealand (GMT+12:45)"
	},
	"Pacific/Easter": {
		posix: "<-06>6<-05>,M9.1.6/22,M4.1.6/22",
		description: "Easter Island, Chile (GMT-6:00)"
	},
	"Pacific/Efate": {
		posix: "<+11>-11",
		description: "Efate, Vanuatu (GMT+11:00)"
	},
	"Pacific/Fakaofo": {
		posix: "<+13>-13",
		description: "Fakaofo, Tokelau (GMT+13:00)"
	},
	"Pacific/Fiji": {
		posix: "<+12>-12",
		description: "Suva, Fiji (GMT+12:00)"
	},
	"Pacific/Galapagos": {
		posix: "<-06>6",
		description: "Galápagos Islands, Ecuador (GMT-6:00)"
	},
	"Pacific/Gambier": {
		posix: "<-09>9",
		description: "Gambier, French Polynesia (GMT-9:00)"
	},
	"Pacific/Guadalcanal": {
		posix: "<+11>-11",
		description: "Guadalcanal, Solomon Islands (GMT+11:00)"
	},
	"Pacific/Guam": {
		posix: "ChST-10",
		description: "Hagåtña, Guam (GMT+10:00)"
	},
	"Pacific/Honolulu": {
		posix: "HST10",
		description: "Honolulu, Hawaii, United States (GMT-10:00)"
	},
	"Pacific/Kanton": {
		posix: "<+13>-13",
		description: "Kanton Island, Kiribati (GMT+13:00)"
	},
	"Pacific/Kiritimati": {
		posix: "<+14>-14",
		description: "Kiritimati, Kiribati (GMT+14:00)"
	},
	"Pacific/Kosrae": {
		posix: "<+11>-11",
		description: "Kosrae, Micronesia (GMT+11:00)"
	},
	"Pacific/Kwajalein": {
		posix: "<+12>-12",
		description: "Kwajalein, Marshall Islands (GMT+12:00)"
	},
	"Pacific/Marquesas": {
		posix: "<-0930>9:30",
		description: "Marquesas, French Polynesia (GMT-9:30)"
	},
	"Pacific/Nauru": {
		posix: "<+12>-12",
		description: "Yaren, Nauru (GMT+12:00)"
	},
	"Pacific/Niue": {
		posix: "<-11>11",
		description: "Alofi, Niue (GMT-11:00)"
	},
	"Pacific/Norfolk": {
		posix: "<+11>-11<+12>,M10.1.0,M4.1.0/3",
		description: "Kingston, Norfolk Island, Australia (GMT+11:00)"
	},
	"Pacific/Noumea": {
		posix: "<+11>-11",
		description: "Noumea, New Caledonia (GMT+11:00)"
	},
	"Pacific/Pago_Pago": {
		posix: "SST11",
		description: "Pago Pago, American Samoa (GMT-11:00)"
	},
	"Pacific/Palau": {
		posix: "<+09>-9",
		description: "Ngerulmud, Palau (GMT+9:00)"
	},
	"Pacific/Pitcairn": {
		posix: "<-08>8",
		description: "Adamstown, Pitcairn Islands (GMT-8:00)"
	},
	"Pacific/Port_Moresby": {
		posix: "<+10>-10",
		description: "Port Moresby, Papua New Guinea (GMT+10:00)"
	},
	"Pacific/Rarotonga": {
		posix: "<-10>10",
		description: "Rarotonga, Cook Islands (GMT-10:00)"
	},
	"Pacific/Tahiti": {
		posix: "<-10>10",
		description: "Tahiti, French Polynesia (GMT-10:00)"
	},
	"Pacific/Tarawa": {
		posix: "<+12>-12",
		description: "Tarawa, Kiribati (GMT+12:00)"
	},
	"Pacific/Tongatapu": {
		posix: "<+13>-13",
		description: "Tongatapu, Tonga (GMT+13:00)"
	}
} satisfies IanaCanonTimezones;
